export interface PosterData {
  name: string;
  age: number;
  note: string;
  phone: string;
  contacts: string[];
  lastSeen: string;
  desc: string;
  details: string[];
  photo: string;
  accent: string;
  alert: boolean;
}

const posters: PosterData[] = [
  {
    name: 'Андрей Корнев (OBLADAET)',
    age: 21,
    note: 'Внимание! Пропал негретёнок',
    phone: '3-67-22',
    contacts: ['3-67-22 или 02 — милиция', '1-23-41 — ЮАР'],
    lastSeen: '18 июня около 10:40, 7-й корпус',
    desc:
      'Ученик ЯРГУ им. П.Г.Демидова группы ИБ 2022 года поступления. Ушёл в ПБ и не вернулся. Последний раз был на экзамене Власовой О.В.',
    details: [
      'Рост 170 см, глаза карие, волосы тёмные, спортивное телосложение.',
      'Был одет в дрип аутфит.',
      'Чёрный.',
    ],
    photo: '/missing-wall/Andrew.jpg',
    accent: '#f3f4f6',
    alert: true,
  },
  {
    name: 'Савелий Крылов (Математик)',
    age: 24,
    note: 'Внимание! Пропал ребёнок',
    phone: '3-67-22',
    contacts: ['3-67-22 или 02 — милиция', '2-31-89 — МФТИ'],
    lastSeen: '18 июня около 10:40, 7-й корпус',
    desc:
      'Ученик ЯРГУ им. П.Г.Демидова группы ИБ 2022 года поступления. Ушёл в работу и работа поглотила его. Последний раз был.',
    details: [
      'Рост 200 см, глаза голубые, волосы тёмные, полное телосложение.',
      'Был одет в штаны парашюты и худи с похабными надписями',
      'При себе имел учебник Климова по мат. Анализу и обширные знания в математике/физике.',
    ],
    photo: '/missing-wall/Sava.jpg',
    accent: '#f3f4f6',
    alert: true,
  },
  {
    name: 'Дмитрий Лыжин (Механик)',
    age: 21,
    note: 'Внимание! Пропал ребёнок',
    phone: '3-67-22',
    contacts: ['3-67-22 или 02 — милиция', '7-25-48 — Сельхозка'],
    lastSeen: '23 января около 10:40, 7-й корпус',
    desc:
      'Ученик ЯРГУ им. П.Г.Демидова группы ИБ 2022 года поступления. Забыл что такое стэк и решил заняться проводкой.',
    details: [
      'Рост 180 см, глаза голубые, волосы тёмные, полное телосложение.',
      'Был одет как батя в 90-ых.',
      'При себе мог иметь ключи от машины, набор отвёрток, сварочный аппарат, мультитул, и вщ что угодно может даже оружие будьте аккуратны',
    ],
    photo: '/missing-wall/Dima.jpg',
    accent: '#f3f4f6',
    alert: true,
  },
  {
    name: 'Илюха Звонов (Батя)',
    age: 21,
    note: 'Внимание! Пропал ребёнок',
    phone: '3-67-22',
    contacts: ['3-67-22 или 02 — милиция', '4-32-43 — Хмель и Гриль'],
    lastSeen: '18 июня около 10:40, 7-й корпус',
    desc:
      'Ученик ЯРГУ им. П.Г.Демидова группы ИБ 2022 года поступления. Решил бахнуть пива, но понял что на пиве можно не только кайфануть, но и заработать.',
    details: [
      'Рост 170 см, глаза голубые, волосы русские, полное телосложение.',
      'Был одет в свитер.',
      'При себе мог иметь пару баулов пива и ксочку.',
    ],
    photo: '/missing-wall/Ilya.jpg',
    accent: '#f3f4f6',
    alert: true,
  },
  {
    name: 'Кирилл Голубков (Умеет Летать)',
    age: 21,
    note: 'Внимание! Пропал ребёнок',
    phone: '3-67-22',
    contacts: ['3-67-22 или 02 — милиция', '34-23-4 — Снеакер Бокс'],
    lastSeen: '18 июня около 10:40, 7-й корпус',
    desc: 'Ученик ЯРГУ им. П.Г.Демидова группы ИБ 2022 года поступления. Не добил ассемблер.',
    details: [
      'Рост 170 см, глаза карие, волосы тёмные, худощавое телосложение.',
      'Был одет в дрип аутфит.',
      'При себе мог иметь пару пар кроссовок марки "GREBOK", и тряпочку для протирки айфонов',
    ],
    photo: '/missing-wall/Kirill.jpg',
    accent: '#f3f4f6',
    alert: true,
  },
];

export default posters;
